/**
 * Shared validation constants for input field validation across the application.
 * DQ-8614: All text input fields must reject invalid special characters.
 * Password and Email fields are explicitly exempt from this restriction.
 */

/**
 * Exhaustive list of special characters that are NOT permitted in general
 * text input fields (names, codes, descriptions, usernames, etc.).
 *
 * Allowed characters (by omission from this list):
 *   - Letters     : a–z, A–Z
 *   - Digits      : 0–9
 *   - Space       : ' '
 *   - Underscore  : _
 *   - Hyphen      : -
 *   - Period      : .
 *
 * Exemptions:
 *   - Password fields : may contain any character (security requirement)
 *   - Email fields    : validated by email format rules, not this list
 *   - Query/SQL fields: contain SQL syntax that requires special characters
 *   - URL fields      : contain :, /, . which are required for valid URLs
 */
export const INVALID_SPECIAL_CHARACTERS: string[] = [
  "!", "@", "#", "$", "%", "^", "&", "*",
  "(", ")", "+", "=", "[", "]", "{", "}",
  "|", "\\", ";", "'", '"', ":", ",",
  "<", ">", "/", "?", "~", "`",
];

/**
 * Pre-compiled regex derived from INVALID_SPECIAL_CHARACTERS.
 * Returns true if the value contains at least one invalid special character.
 *
 * Character class breakdown (all chars from the list above, properly escaped):
 *   ! @ # $ % ^ & * ( ) + = [ ] { } | \ ; ' " : , < > / ? ~ `
 */
export const INVALID_SPECIAL_CHARS_REGEX =
  /[!@#$%^&*()+\=\[\]{}|\\;'":<>,/?~`]/;

/**
 * Standard user-facing validation message shown when an invalid special
 * character is detected in a text input field (per DQ-8614 ticket spec).
 */
export const SPECIAL_CHARS_VALIDATION_MESSAGE =
  "Special characters are not allowed. Please enter valid alphanumeric values.";
